import i18n from '../lang/index'

/**
 * 设置用户鉴权token
 * @param {String} token jwt token
 **/
function setToken(token) {
  return setCookie('agent_token', token);
}

//设置cookie
function setCookie(name,value, domain = ''){
    if(!name||!value) return;
    var Days = 30;//默认30天
    var exp  = new Date();
    exp.setTime(exp.getTime() + Days*24*60*60*1000);
    document.cookie = name + "="+ encodeURIComponent(value) +";expires="+ exp.toUTCString()+ "; path=/;domain="+(domain == '' ? getCookie('cookieDomain') : domain);
}

//获取cookie
function getCookie(name){
    var arr = document.cookie.match(new RegExp("(^| )"+name+"=([^;]*)(;|$)"));
    if(arr != null) return decodeURIComponent(arr[2]);
    return null;
}

//删除cookie
function delCookie(name){
  var date=new Date();
  date.setTime(date.getTime()-10000);
  document.cookie=name+"=; expire="+date.toGMTString()+"; path=/;domain=.yisu.com";
}

/**
 *价格加逗号
 **/
 function commafy(num) {
    return num && num.toString()
      .replace(/\d+/, function (s) {
        return s.replace(/(\d)(?=(\d{3})+$)/g, '$1,')
      })
  }

Date.prototype.Format = function (fmt) {
  var o = {
      "M+": this.getMonth() + 1,
      "d+": this.getDate(),
      "H+": this.getHours(),
      "m+": this.getMinutes(),
      "s+": this.getSeconds(),
      "q+": Math.floor((this.getMonth() + 3) / 3),
      "S": this.getMilliseconds()
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
      if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
}

//高防IP 相关 start --------------------
// 转换host，将test.abc.com置换
function transformHost(host) {
      let expr1 = /test.abc.com/;
      if (expr1.test(host)) {
          return "";
      }else {
          return host;
      }
}

    // 客户端IP标记亿速云官方
function markRemoteAddr(remote_addr) {
    let expr1 = /120.132.124.61/;
    let expr2 = /114.118.3.85/;
    if (expr1.test(remote_addr) || expr2.test(remote_addr)) {
        return '<span class="yisu_ip">' + remote_addr + '&nbsp;<img src="https://cache.yisu.com/www/images/favicon.ico"/></span>';
    }else {
        return remote_addr;
    }
}

  // 根据user-agent解析爬虫类型
  function parseSpider(ua) {
    let expr1 = /Baiduspider/;
    let expr2 = /Googlebot/;
    let expr3 = /bingbot/;
    if (expr1.test(ua)) {
        return 'Baiduspider';
    }else if (expr2.test(ua)) {
        return 'Googlebot';
    }else if (expr3.test(ua)) {
        return 'bingbot';
    }else {
        return '';
        //return '<div class="dated"><span>非爬虫</span></div>';
    }
}
// 包装是否放行
function wrapTypeAndIsJs(type, is_js, status) {
  // 观察模式
  let watch_expr1 = /access_w_/;
  // 普通模式
  let expr1 = /access/;
  let expr2 = /cc_real_/;
  let expr3 = /cc_/;
  let expr4 = /custom_/;
  // 状态码
  let status_expr1 = /^2/;
  let status_expr2 = /^3/;

  let permission = 1;//1表示放行，2表示拦截，3表示异常

  let is_js_status = 1; //1表示放行，2表示未触发，3验证失败

  if (is_js) {
    is_js = i18n.t('defense.util.Failed');is_js_status=3;
  }else {
    is_js = i18n.t('defense.util.NotTriggered');is_js_status=2;
  }

  if (watch_expr1.test(type)) {
    type = i18n.t('defense.util.WatchAccess');
    permission = 1;
    if (!(status_expr1.test(status) || status_expr2.test(status))) {
      type = i18n.t('defense.util.Abnormal');
      permission = 3;
    }
  }else if (expr1.test(type)) {
    type = i18n.t('defense.util.Access');permission = 1;
    if (!(status_expr1.test(status) || status_expr2.test(status))) {
      type = i18n.t('defense.util.Abnormal');permission = 3;
    }
  }else if (expr2.test(type)) {
    type = i18n.t('defense.util.Blocked');permission = 2;
  }else if (expr3.test(type)) {
    type = i18n.t('defense.util.AITriggered');permission = 2;
    if (!is_js) {
      is_js = i18n.t('defense.util.Access');is_js_status=1;
    }
  }else if (expr4.test(type)) {
    type = i18n.t('defense.util.RulesBlocked');permission = 2;
  }

  return {type: type, is_js: is_js,permission:permission,is_js_status:is_js_status}
}
//高防IP 相关 end --------------------
//获取当前币种
function getCurrency() {
  let currency = getCookie('currency');
  if(!currency) currency = '$';
  return currency;
}

//获取当前币种相对汇率
function getCurrencyRate() {
  let currencyRate = getCookie('currencyRate');
  if(!currencyRate) currencyRate = 1;
  return currencyRate;
}

//货币费率转换
function convertCurrency(price) {
  return formatMoney(CurrencyFomatNumber(price,2)*getCurrencyRate());
}



//将货币格式的字符串转换成数字
function CurrencyFomatNumber(number, n) {
  if (number != null && number != "" && number != undefined) {
    number = number.toString();
    number = number.replace(/,/g, "");
    if (isNaN(number)) {
      number = "0";
    } else {
      number = Math.round(number * Math.pow(10, n)) / Math.pow(10, n);
      number = number.toString();
    }
  } else {
    number = "0";
  }
  var numLength = number.indexOf('.');
  if (numLength < 0) {
    numLength = number.length;
    number += '.';
  }
  while (number.length <= numLength + n) {
    number += '0';
  }
  return number;
}

//将数字转换成货币格式
function formatMoney(number, places, symbol, thousand, decimal) {
  number = number || 0;
  places = !isNaN(places = Math.abs(places)) ? places : 2;
  symbol = symbol !== undefined ? symbol : "";
  thousand = thousand || ",";
  decimal = decimal || ".";
  var negative = number < 0 ? "-" : "",
    i = parseInt(number = Math.abs(+number || 0).toFixed(places), 10) + "",
    j = (j = i.length) > 3 ? j % 3 : 0;
  return symbol + negative + (j ? i.substr(0, j) + thousand : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousand) + (places ? decimal + Math.abs(number - i).toFixed(places).slice(2) : "");
}

//统一处理JS错误
function handleErr(err) {
   console.log('ERR:'+err);
}

function getWWWUrl()
{
    let wwwUrl = getCookie('agent_belong_agent');
    if (wwwUrl == null) {
      wwwUrl = localStorage.getItem('agent_belong_agent');
    }
    return wwwUrl === null ? '' : (location.protocol+'//' + wwwUrl);
}

function getLoginUrl()
{
    return getWWWUrl() + '/login';
}

function getApiUrl()
{
  let apiUrl = getCookie('yisuApiHost');
  if (apiUrl == null || apiUrl == '') {
    apiUrl = process.env.YISU_API_URL;
  }
  //console.log("当前APIURL : " + apiUrl);
  return apiUrl;
}

function timestampToTime(timestamp) {
  var date = new Date(timestamp);//时间戳为10位需*1000，13位的话不需要
  var Y = date.getFullYear() + "-";
  var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
  var D = date.getDate() + " ";
  var H = date.getHours() + ":";
  var MIN = date.getMinutes() + ":";
  var S = date.getSeconds();
  return Y+M+D+H+MIN+S;
 }
export default {setToken, getCookie, setCookie, delCookie,transformHost,markRemoteAddr,parseSpider,wrapTypeAndIsJs,commafy,convertCurrency,getCurrency,handleErr, getWWWUrl, getLoginUrl, getApiUrl,timestampToTime}



// WEBPACK FOOTER //
// ./src/utils/util.js